import React, { useState, useEffect, useRef } from 'react';
import { Box, IconButton } from '@chakra-ui/react';
import { HiMiniSpeakerWave, HiMiniSpeakerXMark } from "react-icons/hi2";
import { useCurrentAccount } from '@mysten/dapp-kit';
//
const AudioController = ({ isVideoPlaying, showFullScreen }) => {
    const [isMuted, setIsMuted] = useState(true);
    const staticAudioRef = useRef(null);
    const videoAudioRef = useRef(null);
    const hasInteractedRef = useRef(false);
    const account = useCurrentAccount();

    // Function to attempt playing static audio
    const tryPlayStatic = async () => {
        if (staticAudioRef.current && !showFullScreen && !isMuted && !isVideoPlaying && !account) {
            try {
                await staticAudioRef.current.play();
            } catch (error) {
                console.log("Autoplay prevented, waiting for user interaction");
            }
        }
    };

    // Setup audio elements
    useEffect(() => {
        const staticAudio = new Audio('/static.mp3');
        staticAudio.loop = true;
        staticAudio.volume = 0.03;
        staticAudioRef.current = staticAudio;

        // Create video audio element
        const videoAudio = document.querySelector('video');
        if (videoAudio) {
            videoAudio.volume = 0.03;
            videoAudioRef.current = videoAudio;
        }

        // Add interaction listener to document
        const handleInteraction = () => {
            if (!hasInteractedRef.current) {
                hasInteractedRef.current = true;
                tryPlayStatic();
            }
        };

        document.addEventListener('click', handleInteraction);
        document.addEventListener('touchstart', handleInteraction);

        // Try initial play
        tryPlayStatic();

        return () => {
            staticAudio.pause();
            staticAudio.src = '';
            document.removeEventListener('click', handleInteraction);
            document.removeEventListener('touchstart', handleInteraction);
        };
    }, []);

    // Handle state changes
    useEffect(() => {
        if (!showFullScreen && !isMuted && !isVideoPlaying && !account) {
            tryPlayStatic();
        } else if (staticAudioRef.current) {
            staticAudioRef.current.pause();
        }
    }, [showFullScreen, isMuted, isVideoPlaying, account]);

    useEffect(() => {
        if (videoAudioRef.current) {
            videoAudioRef.current.muted = isMuted;
        }
    }, [isMuted]);

    // Stop static when wallet connects
    useEffect(() => {
        if (account && staticAudioRef.current) {
            staticAudioRef.current.pause();
        }
    }, [account]);

    const toggleMute = async () => {
        setIsMuted(!isMuted);
        hasInteractedRef.current = true;
    };

    if (showFullScreen) return null;

    return (
        <Box
            position="fixed"
            bottom="20px"
            right="15px"
            zIndex={1000}
            bg="rgba(0, 0, 0, 0.5)"
            p={2}
            borderRadius="full"
            backdropFilter="blur(10px)"
        >
            <IconButton
                icon={isMuted ? <HiMiniSpeakerXMark size={24} /> : <HiMiniSpeakerWave size={24} />}
                onClick={toggleMute}
                variant="ghost"
                color="white"
                _hover={{ bg: 'whiteAlpha.200' }}
                aria-label={isMuted ? "Unmute" : "Mute"}
                fontSize="24px"
                padding={6}
            />
        </Box>
    );
};

export default AudioController; 